import React, { useCallback } from 'react';

import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button, { type ButtonProps } from '@atlaskit/button/new';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { useIntl } from '@atlassian/jira-intl';

import messages from './messages.tsx';

type ControlItemType = 'cancel' | 'back' | 'get-started';

const controlItemMessageMap = {
	cancel: messages.close,
	back: messages.back,
	'get-started': messages.getStarted,
} as const;

const controlItemActionSubjectMap = {
	cancel: 'cancel',
	back: 'back',
	'get-started': 'getStarted',
} as const;

export const ControlItem = ({
	onClick,
	variant,
	disabled = false,
	...props
}: Omit<ButtonProps, 'children'> & {
	variant: ControlItemType;
	disabled?: boolean;
}) => {
	const { formatMessage } = useIntl();

	const handleClick: ButtonProps['onClick'] = useCallback(
		(e: React.MouseEvent<HTMLButtonElement>, analyticsEvent: UIAnalyticsEvent) => {
			onClick?.(e, analyticsEvent);
			fireUIAnalytics(analyticsEvent, controlItemActionSubjectMap[variant]);
		},
		[onClick, variant],
	);
	return (
		<Button
			interactionName="onboarding-control"
			onClick={handleClick}
			isDisabled={disabled}
			{...props}
		>
			{formatMessage(controlItemMessageMap[variant])}
		</Button>
	);
};
